import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap';

import { CheckboxField } from '../../../blocks/edit_blocks';
import { formatDateTime } from '../../../tools/converters';
import Pocket from '../Pocket';

const idByLangMap = {
    ru: 2,
    en: 3,
};

export default function PocketGofFeaturing({ lang }) {
    return (
        <Pocket
            isFlex
            key={lang}
            itemsLimit={10}
            currentLang={lang}
            endpoint={`v2/gof.vkplay.ru/pockets/${idByLangMap[lang]}/`}
            renderColumns={({ editItem, deleteItem, handleActive }) => ([
                {
                    Header: 'Вкл',
                    sortable: false,
                    accessor: 'id',
                    maxWidth: 40,
                    Cell: (row) => (
                        <ButtonToolbar>
                            <ButtonGroup>
                                <CheckboxField
                                    name={row.row.id}
                                    dataValue="is_active"
                                    label=""
                                    value={row.original.is_active | false}
                                    onChange={handleActive}
                                />
                            </ButtonGroup>
                        </ButtonToolbar>
                    ),
                },
                {
                    Header: 'Заголовок',
                    sortable: false,
                    accessor: 'title',
                    minWidth: 200,
                },
                {
                    Header: 'Заверш. пок.',
                    sortable: false,
                    accessor: 'finish',
                    minWidth: 100,
                    Cell: (row) => (formatDateTime(row.value)),
                },
                {
                    Header: 'Нач. пок.',
                    sortable: false,
                    accessor: 'start',
                    minWidth: 100,
                    Cell: (row) => (formatDateTime(row.value)),
                },
                {
                    Header: 'Заверш. пок. 2',
                    sortable: false,
                    accessor: 'finish_2',
                    minWidth: 100,
                    Cell: (row) => (formatDateTime(row.value)),
                },
                {
                    Header: 'Нач. пок. 2',
                    sortable: false,
                    accessor: 'start_2',
                    minWidth: 100,
                    Cell: (row) => (formatDateTime(row.value)),
                },
                {
                    Header: '',
                    sortable: false,
                    accessor: 'id',
                    maxWidth: 70,
                    Cell: (row) => (
                        <ButtonToolbar>
                            <ButtonGroup>
                                <Button
                                    size="sm"
                                    variant="link"
                                    data-id={row.row.id}
                                    data-value={row.value}
                                    onClick={editItem}
                                >
                                    <FontAwesomeIcon icon="pencil-alt" />
                                </Button>
                                <Button
                                    size="sm"
                                    variant="link"
                                    data-id={row.row.id}
                                    data-title={row.original.title}
                                    data-value={row.value}
                                    onClick={deleteItem}
                                >
                                    <FontAwesomeIcon icon="trash" />
                                </Button>
                            </ButtonGroup>
                        </ButtonToolbar>
                    ),
                },
            ])}
            formFields={[
                {
                    type: 'textarea',
                    name: 'title',
                    label: 'Заголовок',
                    maxLength: 128,
                    textareaRows: 3,
                    isRequired: true,
                },
                {
                    type: 'input',
                    name: 'link_label',
                    label: 'Текст кнопки',
                    maxLength: 20,
                    isRequired: true,
                },
                {
                    type: 'input',
                    name: 'link',
                    label: 'Ссылка',
                    isRequired: true,
                },
                {
                    type: 'date-time',
                    name: 'finish',
                    label: 'Завершение показа',
                },
                {
                    type: 'date-time',
                    name: 'start',
                    label: 'Начало показа',
                },
                {
                    type: 'date-time',
                    name: 'finish_2',
                    label: 'Завершение показа 2',
                },
                {
                    type: 'date-time',
                    name: 'start_2',
                    label: 'Начало показа 2',
                },
                {
                    type: 'image',
                    name: 'picture',
                    label: 'Изображение (desktop)',
                    imageMinSize: '760x320',
                    isRequired: true,
                },
                {
                    type: 'image',
                    name: 'picture_mobile',
                    label: 'Изображение (mobile)',
                    imageMinSize: '320x320',
                    isRequired: true,
                },
            ]}
        />
    );
}
